import.meta.glob("../admin/initializers/*.js", { eager: true })

import "@hotwired/turbo-rails"

import Rails from "@rails/ujs"
Rails.start()
window.Rails = Rails

import "bootstrap"
import "selectize"
import "tom-select"
import "@butterflymx/cocoon"

import "../admin/controllers"
